export const LOGOUT_BACK_URL_PARAM = 'back_url'
export const BUSINESS_EXTERNAL_ACTION_PARAM = 'action'
export enum BUSINESS_EXTERNAL_ACTIONS {
  LOGOUT = 'logout'
}
